// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomColorSelector_container__3OlbW","rightBlock":"CustomColorSelector_rightBlock__NX8P3","hueWrapper":"CustomColorSelector_hueWrapper__Dtbh3"};